const GiftCardStatus = Object.freeze({
  FULL_CREDIT: 1,
  USED: 2,
  EMPTY: 3,
  EXPIRED: 4,
  SITE_UNACTIVE: 5,
});

export default GiftCardStatus;
